import React, { useMemo } from "react";
import "./style.css";

/**
 * @param {{ items: Array<{ amount: number, optional?: boolean }> }} props
 */
export default function InvoiceTotals({ items }) {
	const computed = useMemo(() => {
		const safeItems = items || [];

		const requiredSubtotal = safeItems.reduce((sum, item) => {
			if (item.optional) return sum;
			return sum + (Number(item.amount) || 0);
		}, 0);

		const optionalSubtotal = safeItems.reduce((sum, item) => {
			if (!item.optional) return sum;
			return sum + (Number(item.amount) || 0);
		}, 0);

		const taxRate = 0;
		const requiredTax = requiredSubtotal * (taxRate / 100);
		const requiredTotal = requiredSubtotal + requiredTax;

		const fullSubtotal = requiredSubtotal + optionalSubtotal;
		const fullTax = fullSubtotal * (taxRate / 100);
		const fullTotal = fullSubtotal + fullTax;

		const amountPaid = 0;
		const balance = fullTotal - amountPaid;

		return {
			requiredSubtotal,
			optionalSubtotal,
			requiredTax,
			requiredTotal,
			fullTax,
			fullTotal,
			taxRate,
			amountPaid,
			balance
		};
	}, [items]);

	return (
		<div className="invoice-section">
			<h3 className="invoice-section-title">Summary</h3>

			<div className="invoice-totals">
				<div className="invoice-total-row">
					<span className="muted">Subtotal (Required)</span>
					<span className="value">ZAR {computed.requiredSubtotal.toFixed(2)}</span>
				</div>

				<div className="invoice-total-row">
					<span className="muted">Optional Items</span>
					<span className="value">ZAR {computed.optionalSubtotal.toFixed(2)}</span>
				</div>

				<div className="invoice-total-row invoice-total-row--divider">
					<span className="strong">Total (Required)</span>
					<span className="value value--total">ZAR {computed.requiredTotal.toFixed(2)}</span>
				</div>

				<div className="invoice-total-row">
					<span className="muted">Total (Incl. Optional)</span>
					<span className="value value--total">ZAR {computed.fullTotal.toFixed(2)}</span>
				</div>

				{/* <div className="invoice-total-row">
					<span className="muted">Amount Paid</span>
					<span className="value">ZAR {computed.amountPaid.toFixed(2)}</span>
				</div> */}

				<div className="invoice-total-row invoice-total-row--balance">
					<span className="balance-label">Balance Due</span>
					<span className="balance-value">ZAR {computed.balance.toFixed(2)}</span>
				</div>
			</div>
		</div>
	);
}
